import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { ITask2ReportItem } from '../../fi-task-v2-report';
import { FiTaskType } from '@fi-app/task-v2/fi-task-v2-enums';
import { FiInfoIconMode } from '@fi-app/shared/info-icon/info-icon.component';
import { ITaskV2ChecklistDataBase } from '@fi-app/task-v2/fi-task-v2';
import { AppTextService } from '@fi-shared/app-text';
import { Checkpoint2StatusType } from '@fi-shared/checklist/checklist-enum';

@Component({
    selector: 'fi-system-task-tooltip-icon',
    templateUrl: './system-task-tooltip-icon.component.html',
    styleUrls: ['./system-task-tooltip-icon.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-system-task-tooltip-icon' },
    standalone: false,
})
export class SystemTaskTooltipIconComponent {
    @Input() item: ITask2ReportItem;
    protected readonly FiInfoIconMode = FiInfoIconMode;

    protected get checklistData(): ITaskV2ChecklistDataBase {
        return this.item.AdditionalData?.ChecklistData;
    }

    protected getSystemTaskIconClass(): string {
        if (this.checklistData?.IsChecklistAudit) {
            return 'far fa-person-chalkboard';
        }
        return 'far fa-ballot-check';
    }

    constructor(private appTextService: AppTextService) {}

    protected get tooltipHeaderTextId(): string {
        if (this.isAutomatedTask()) {
            return 'checklist.checkpoint_action_automated_task';
        }
        return 'checklist.checkpoint_action_one_time_task';
    }

    protected getTooltipText(): string {
        if (this.checklistData?.CheckpointAnswerStatus === Checkpoint2StatusType.NotOk) {
            return this.appTextService.get('task.automated_task_not_ok_tooltip', {
                '{0}': this.item.Name,
                '{1}': this.checklistData?.UserFullName,
                '{2}': this.checklistData?.BusinessUnitName,
                '{3}': this.checklistData?.CheckpointName,
                '{4}': this.getTaskModuleLabel(),
                '{5}': this.checklistData?.ChecklistName,
            });
        }
        return this.appTextService.get('task.automated_task_skipped_tooltip', {
            '{0}': this.item.Name,
            '{1}': this.checklistData?.BusinessUnitName,
            '{2}': this.checklistData?.CheckpointName,
            '{3}': this.getTaskModuleLabel(),
            '{4}': this.checklistData?.ChecklistName,
        });
    }

    private getTaskModuleLabel(): string {
        return this.appTextService.get(
            this.checklistData?.IsChecklistAudit ? 'checklist.audit_checklist' : 'task.report_checklsit_module_name',
        );
    }

    private isAutomatedTask(): boolean {
        return this.item.TaskType === FiTaskType.ChecklistAutomated;
    }

    private isOneTimeTask(): boolean {
        return this.item.TaskType === FiTaskType.ChecklistOneTime;
    }
}
